import { CommonModule } from '@angular/common'
import { Component, HostBinding, effect, input } from '@angular/core'
import { PillType } from '@shared-ui-lib/pill/pill.model'

@Component({
    selector: 'app-pill',
    templateUrl: './pill.component.html',
    styleUrls: ['./pill.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class PillComponent {
    readonly pillType = input<PillType>()

    @HostBinding('class.info') _info = false
    @HostBinding('class.important') _important = false
    @HostBinding('class.default') _default = true

    constructor() {
        effect(() => {
            this._info = this._important = this._default = false

            switch (this.pillType()) {
                case 'info':
                    this._info = true
                    break
                case 'important':
                    this._important = true
                    break
                case 'default':
                    this._default = true
                    break
                default:
                    this._default = true
                    break
            }
        })
    }
}
